import { render } from "./profile-documentation.vue?vue&type=template&id=263ba314"
import script from "./profile-documentation.vue?vue&type=script&lang=js"
export * from "./profile-documentation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__